import React from 'react'
import PropTypes from 'prop-types'

import { ComponentVariant } from '../../../utils/typeDefinitions/main'

import T010M from './T010M'
import T010L from './T010L'

const T010 = (props) => {
  const { settings } = props

  switch (settings.variant) {
    case ComponentVariant.MEDIUM:
    default:
      return <T010M {...props} />

    case ComponentVariant.LARGE:
      return <T010L {...props} />
  }
}

T010.propTypes = {
  settings: PropTypes.shape({
    variant: PropTypes.oneOf([ComponentVariant.MEDIUM, ComponentVariant.LARGE]),
  }),
}

T010.defaultProps = {
  settings: {
    variant: ComponentVariant.MEDIUM,
  },
}

export default T010
